import { gql } from 'apollo-boost';

import { bannerImageFragment } from '../../queries/grid/domain';

const ValidationError = gql`
    fragment ValidationError on GdDefect {
        code
        params
        path
    }
`;

const ValidationWarning = gql`
    fragment ValidationWarning on GdDefect {
        code
        params
        path
    }
`;

export const addSitelinkSet = gql`
    mutation AddSitelinkSets(
        $input: GdAddSitelinkSetsInput!
    	$login: String!
    ) {
        reqId: getReqId
        addSitelinkSets(input: $input) {
            addedSitelinkSets {
                id
                __typename
            }
            validationResult {
                errors {
                    ...ValidationError
                    __typename
                }
                warnings {
                    ...ValidationWarning
                    __typename
                }
                __typename
            }
            __typename
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
    
    ${ValidationError},
    ${ValidationWarning}
`;

export const updateAdPrices = gql`
     mutation updateAdPrices(
    	$input: [GdUpdateAdPriceInput!]!
	) {
        updateAdPrices(input: $input) {
            updatedAds {
                id
            }
            validationResult {
                errors {
                    ...ValidationError
                }
                warnings {
                    ...ValidationWarning
                }
            }
        }
    }

    ${ValidationError},
    ${ValidationWarning}
`;

export const updateAdPricesMass = gql`
    mutation updateAdPrices($input: [GdUpdateAdPriceInput!]!) {
        updateAdPrices(input: $input) {
            updatedAds {
                id
            }
        }
    }
`;

const AddAds = gql`
    fragment AddAds on GdAddAdsPayload {
        addedAds {
            id
        }
        validationResult {
            errors {
                ...ValidationError
            }
            warnings {
                ...ValidationWarning
            }
        }
    }
    ${ValidationError},
    ${ValidationWarning}
`;

const AddCpmAds = gql`
    fragment AddCpmAds on GdAddAdsPayload {
        addedAds {
            id
        }
        validationResult {
            errors {
                ...ValidationError
            }
            warnings {
                ...ValidationWarning
            }
        }
    }
    ${ValidationError},
    ${ValidationWarning}
`;

const UpdateCpmAds = gql`
    fragment UpdateCpmAds on GdUpdateAdsPayload {
        updatedAds {
            id
        }
        validationResult {
            errors {
                ...ValidationError
            }
            warnings {
                ...ValidationWarning
            }
        }
    }
    
    ${ValidationError},
    ${ValidationWarning}
`;

const AddMcBannerAds = gql`
    fragment AddMcBannerAds on GdAddAdsPayload {
        addedAds {
            id
        }
        validationResult {
            errors {
                ...ValidationError
            }
            warnings {
                ...ValidationWarning
            }
        }
    }
    ${ValidationError},
    ${ValidationWarning}
`;

const UpdateMcBannerAds = gql`
    fragment UpdateMcBannerAds on GdUpdateAdsPayload {
        updatedAds {
            id
        }
        validationResult {
            errors {
                ...ValidationError
            }
            warnings {
                ...ValidationWarning
            }
        }
    }
    
    ${ValidationError},
    ${ValidationWarning}
`;

const AddContentPromotionAds = gql`
    fragment AddContentPromotionAds on GdAddAdsPayload {
        addedAds {
            id
        }
        validationResult {
            errors {
                ...ValidationError
            }
            warnings {
                ...ValidationWarning
            }
        }
    }

    ${ValidationError},
    ${ValidationWarning}
`;

const UpdateContentPromotionAds = gql`
    fragment UpdateContentPromotionAds on GdUpdateAdsPayload {
        updatedAds {
            id
        }
        validationResult {
            errors {
                ...ValidationError
            }
            warnings {
                ...ValidationWarning
            }
        }
    }

    ${ValidationError},
    ${ValidationWarning}
`;

const AddSmartAds = gql`
    fragment AddSmartAds on GdAddAdsPayload {
        addedAds {
            id
        }
        validationResult {
            errors {
                ...ValidationError
            }
            warnings {
                ...ValidationWarning
            }
        }
    }
    
    ${ValidationError},
    ${ValidationWarning}
`;

const UpdateSmartAds = gql`
    fragment UpdateSmartAds on GdUpdateAdsPayload {
        updatedAds {
            id
        }
        validationResult {
            errors {
                ...ValidationError
            }
            warnings {
                ...ValidationWarning
            }
        }
    }
    
    ${ValidationError},
    ${ValidationWarning}
`;

const DeleteAdsWithValidation = gql`
    fragment DeleteAdsWithValidation on GdAdsMassActionPayload {
        validationResult {
            errors {
                ...ValidationError
            }
            warnings {
                ...ValidationWarning
            }
        }
    }
    
    ${ValidationError},
    ${ValidationWarning}
`;

const UpdateAds = gql`
    fragment UpdateAds on GdUpdateAdsPayload {
        updatedAds {
            id
        }
        validationResult {
            errors {
                ...ValidationError
            }
            warnings {
                ...ValidationWarning
            }
        }
    }
    
    ${ValidationError},
    ${ValidationWarning}
`;

export const updateAdsMutation = gql`
    mutation UpdateAdsMutation($input: GdUpdateAdsInput!, $login: String!) {
        reqId: getReqId
        updateAds(input: $input) {
            ...UpdateAds
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }

    ${UpdateAds}
`;

export const addAdsMutation = gql`
    mutation AddAdsMutation($input: GdAddAdsInput!, $login: String!) {
        reqId: getReqId
        addAds(input: $input) {
            ...AddAds
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }

    ${AddAds}
`;

export const saveAdsMutation = gql`
    mutation SaveAdsMutation(
        $addInput: GdAddAdsInput!
        $updateInput: GdUpdateAdsInput!
        $updateSmartAds: GdUpdateSmartAdsInput!
        $smartAds: GdAddSmartAdsInput!
        $addCpmAdsInput: GdAddCpmAdsInput!
        $updateCpmAdsInput: GdUpdateCpmAdsInput!
        $deleteInput: GdAdsMassActionInput!
        $addMcBannerInput: GdAddMcBannerAdsInput!
        $updateMcBannerInput: GdUpdateMcBannerAdsInput!
        $addContentPromotionAdsInput: GdAddContentPromotionAdsInput!
        $updateContentPromotionAdsInput: GdUpdateContentPromotionAdsInput!
        $login: String!
    ) {
        reqId: getReqId

        addAds(input: $addInput) {
            ...AddAds
        }

        updateAds(input: $updateInput) {
            ...UpdateAds
        }

        updateSmartAds(input: $updateSmartAds) {
            ...UpdateSmartAds
        }

        addSmartAds(input: $smartAds) {
            ...AddSmartAds
        }

        addCpmAds(input: $addCpmAdsInput) {
            ...AddCpmAds
        }

        updateCpmAds(input: $updateCpmAdsInput) {
            ...UpdateCpmAds
        }

        addMcBannerAds(input: $addMcBannerInput) {
            ...AddMcBannerAds
        }

        updateMcBannerAds(input: $updateMcBannerInput) {
            ...UpdateMcBannerAds
        }

        addContentPromotionAds(input: $addContentPromotionAdsInput) {
            ...AddContentPromotionAds
        }

        updateContentPromotionAds(input: $updateContentPromotionAdsInput) {
            ...UpdateContentPromotionAds
        }

        deleteAds(input: $deleteInput) {
            ...DeleteAdsWithValidation
        }

        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }

    ${AddAds}
    ${AddSmartAds}
    ${UpdateAds}
    ${UpdateSmartAds}
    ${AddCpmAds}
    ${UpdateCpmAds}
    ${AddMcBannerAds}
    ${UpdateMcBannerAds}
    ${AddContentPromotionAds}
    ${UpdateContentPromotionAds}
    ${DeleteAdsWithValidation}
`;

const AddInternalAds = gql`
    fragment AddInternalAds on GdAddAdsPayload {
        addedAds {
            id
        }
        validationResult {
            errors {
                ...ValidationError
            }
            warnings {
                ...ValidationWarning
            }
        }
    }
    ${ValidationError},
    ${ValidationWarning}
`;

const UpdateInternalAds = gql`
    fragment UpdateInternalAds on GdUpdateAdsPayload {
        updatedAds {
            id
        }
        validationResult {
            errors {
                ...ValidationError
            }
            warnings {
                ...ValidationWarning
            }
        }
    }
    
    ${ValidationError},
    ${ValidationWarning}
`;

export const saveInternalAdsMutation = gql`
    mutation SaveInternalAdsMutation(
        $addInput: GdAddInternalAdsInput!
        $updateInput: GdUpdateInternalAdsInput!
        $deleteInput: GdAdsMassActionInput!
        $login: String!
    ) {
        reqId: getReqId

        addInternalAds(input: $addInput) {
            ...AddInternalAds
        }

        updateInternalAds(input: $updateInput) {
            ...UpdateInternalAds
        }

        deleteAds(input: $deleteInput) {
            ...DeleteAdsWithValidation
        }

        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }

    ${AddInternalAds}
    ${UpdateInternalAds}
    ${DeleteAdsWithValidation}
`;

export const addVCards = gql`
    mutation AddVCards($input: GdAddVcardsInput!) {
        reqId: getReqId
        addVcards(input: $input) {
            addedVcards {
                id
            }
            validationResult {
                errors {
                    code
                    params
                    path
                }
                warnings {
                    code
                    params
                    path
                }
            }
        }
    }
`;

export const archiveAds = gql`
    mutation ArchiveAds($input: GdAdsMassActionInput!) {
        reqId: getReqId
        archiveAds(input: $input) {
            processedAdIds
            skippedAdIds
        }
    }
`;

export const unarchiveAds = gql`
    mutation UnarchiveAds($input: GdAdsMassActionInput!) {
        reqId: getReqId
        unarchiveAds(input: $input) {
            processedAdIds
            skippedAdIds
        }
    }
`;

export const suspendAds = gql`
    mutation SuspendAds($input: GdAdsMassActionInput!) {
        reqId: getReqId
        suspendAds(input: $input) {
            processedAdIds
            skippedAdIds
        }
    }
`;

export const resumeAds = gql`
    mutation ResumeAds($input: GdAdsMassActionInput!) {
        reqId: getReqId
        resumeAds(input: $input) {
            processedAdIds
            skippedAdIds
        }
    }
`;

export const deleteAds = gql`
    mutation DeleteAds($input: GdAdsMassActionInput!) {
        reqId: getReqId
        deleteAds(input: $input) {
            processedAdIds
            skippedAdIds
        }
    }
`;

export const updateImageSmartCenters = gql`
    mutation UpdateImageSmartCenters($input: GdUpdateSmartCentersInput!, $login: String!) {
        reqId: getReqId
        updateSmartCenters(input: $input) {
            validationResult {
                errors {
                    ...ValidationError
                }
                warnings {
                    ...ValidationWarning
                }
            }
            image {
                ...adImageFragment
            }
        }

        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
    ${ValidationError},
    ${ValidationWarning}
    ${bannerImageFragment}
`;

export const generateVideoAdditionMutation = gql`
    mutation GenerateVideoAddition($input: GdGenerateVideoAdditionInput!) {
        reqId: getReqId
        generateVideoAddition(input: $input) {
            creativeId
            creativeType
            height
            name
            previewUrl
            width
        }
    }
`;

export const rejectAutoOrganizationsMutation = gql`
    mutation RejectAutoOrganizations($permalinks: [GdUpdateOrganizationInput!]!) {
        reqId: getReqId
        rejectAutoOrganizations(input: $permalinks) {
            updatedAds {
              id
              __typename
            }
            validationResult {
                errors {
                    ...ValidationError
                    __typename
                }
                warnings {
                    ...ValidationWarning
                    __typename
                }
                __typename
            }
        }
    }
    ${ValidationError},
    ${ValidationWarning}
`;
